import { Typography } from 'antd';
import type { ParksTabPageViewProps } from './ParksTabPage.types';

export function ParksTabPageView({ title }: ParksTabPageViewProps) {
  return <Typography.Title level={3}>{title}</Typography.Title>;
}
